import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ITokenized } from '../../types/my-types';
import useGlynt from './useGlynt';

// match todienizer version from training set
const useTokenizedUrl = (defaultUrl: string, docId: string, tokenizerVersion: string) => {
  const [enabled, setEnabled] = useState(true);
  const glynt = useGlynt();
  const { data } = useQuery({
    queryKey: ['tokenizeds', docId],

    queryFn: async () =>
      (await glynt).tokenizeds.list({
        document: docId,
        status: 'Success',
        ordering: '-created_at',
        advanced: true,
      }),

    refetchInterval: 5000
  });

  // get successful tokenized,
  if (data) {
    const tokenizeds = data.results;
    const matched = tokenizeds.filter((tk: ITokenized) => {
      return tk.tokenizer_version === tokenizerVersion;
    })[0];
    if (matched) return matched.url;
  }
  return defaultUrl;
};

export default useTokenizedUrl;
